import SalesTransactionsAPI from 'dashboard/api/salesTransactions';

export const loadSalesCommission = async id => {
  const [saleResponse, catalogResponse] = await Promise.all([
    SalesTransactionsAPI.get(id),
    SalesTransactionsAPI.commissionCatalog(id),
  ]);

  return {
    catalog: catalogResponse.data?.catalog || {},
    transaction: saleResponse.data,
  };
};

export const saveSalesCommissionDraft = async (id, payload) => {
  const response = await SalesTransactionsAPI.saveDraft(id, payload);
  return response.data;
};
